import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import {rotateArrow, CardState, answersExpand} from '../../../../common/animations';

@Component({
  selector: 'as-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss'],
  animations: [ answersExpand]
})
export class CollapseComponent implements OnInit {

  cardState: CardState = CardState.Closed;

  constructor() { }

  @Input() data: any;
  @Input() url: string;
  @Input() type : string;
  @Input() action: string;
  @Input() title : string;
  @Input() height : number;
  @Input() ajax: boolean = false
  @Input() saveButton: string;
  @Input() paddingRem: number = 1.25
  @Input() showBorder: boolean = true;

  @ViewChild("collapse", {static:false}) collapse : ElementRef;

  isOpen = false;

  ngOnInit() {
  }


toggle(){

  this.cardState = ( this.cardState == CardState.Open) ? CardState.Closed : CardState.Open;

}

}
